import { styled, css } from "styled-components";
import theme from "styled-theming";

import { Container as BlockQuote } from "components/BlockQuote/BlockQuote.styled";
import { default as NavLink } from "components/Link";
import { Container as GridContainer } from "style/components/Page";
import {
    styleBodyM,
    styleBodyLAlt,
    styleHeadingXL,
} from "style/components/Typography";
import { columnGap } from "style/grid";
import { MQ } from "style/mediaQueries";

export const borderColor = theme("theme", {
    undefined: "var(--color-black-o30)",
    lightgray: "var(--color-black-o30)",
    blue: "var(--color-cyan-l60-o30)",
    cyan: "var(--color-blue-o30)",
});

export const Container = styled(GridContainer)`
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    padding-bottom: 4.375rem;
    padding-top: 2.1875rem;
    position: relative;

    ${MQ.FROM_M} {
        ${columnGap}
        display: grid;
        grid-auto-rows: auto;
        grid-template-columns: repeat(12, [col-start] 1fr);
        padding-bottom: 6.125rem;
        padding-top: 3.5rem;
    }

    ${MQ.FROM_XL} {
        padding-bottom: 8.75rem;
        padding-top: 4.375rem;
    }
`;

export const Header = styled.div`
    ${MQ.FROM_M} {
        ${columnGap}
        display: grid;
        grid-auto-rows: auto;
        grid-column: col-start 1 / span 12;
        grid-template-columns: repeat(12, [col-start] 1fr);
        margin-bottom: 2.1875rem;
    }
`;

export const Heading = styled.h2`
    ${styleHeadingXL};
    margin-bottom: 2.625rem;
    margin-top: 0;

    ${MQ.FROM_M} {
        grid-column: col-start 1 / span 12;
    }

    ${MQ.FROM_L} {
        grid-column: col-start 1 / span 9;
    }
`;

export const Introduction = styled.p`
    ${styleBodyLAlt};
    margin-bottom: 4.375rem;
    margin-top: 0;

    ${MQ.FROM_M} {
        grid-column: col-start 2 / span 8;
        margin-bottom: 2.1875rem;
    }

    ${MQ.FROM_L} {
        grid-column: col-start 2 / span 6;
    }
`;

export const BlockQuotes = styled.div.attrs<{
    $count: number;
}>(() => ({}))`
    ${columnGap};
    align-items: flex-start;
    display: grid;
    grid-template-columns: repeat(1, [col-start] 1fr);
    row-gap: 2.1875rem;

    ${MQ.FROM_M} {
        grid-column: col-start 1 / span 12;
        grid-template-columns: repeat(2, [col-start] 1fr);
        row-gap: 2.625rem;
    }

    ${MQ.FROM_L} {
        grid-template-columns: repeat(3, [col-start] 1fr);
        row-gap: 2.625rem;
        ${(props) =>
            props.$count === 4
                ? css`
                      ${BlockQuote}:nth-child(3) {
                          grid-column: 2;
                      }
                  `
                : props.$count === 5
                  ? css`
                        ${BlockQuote}:nth-child(4) {
                            grid-column: 2;
                        }
                    `
                  : ""}
    }

    ${MQ.FROM_XL} {
        row-gap: 4.375rem;
    }
`;

export const ReadMoreContainer = styled.div`
    grid-column: col-start 1 / span 12;
    margin-top: 4.375rem;
`;

export const Link = styled(NavLink)`
    ${styleBodyM}
    display: block;
    grid-column: 1 / span 4;
    margin-top: 0.875rem;
    width: 100%;

    span {
        border-bottom-color: ${borderColor};
    }

    &:hover {
        span {
            border-bottom-color: currentcolor;
        }
    }

    svg {
        margin-left: 0.875rem;
    }
`;
